// extracted by mini-css-extract-plugin
var _1 = "FileReplacePreview_divider__8eb51";
var _2 = "FileReplacePreview_fileMeta__3c38c";
var _3 = "FileReplacePreview_image__7eb4f";
var _4 = "FileReplacePreview_info__ec66c";
var _5 = "FileReplacePreview_root__0ee9f";
export { _1 as "divider", _2 as "fileMeta", _3 as "image", _4 as "info", _5 as "root" }
